<template>
  <div>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Data de Início</th>
            <th>Data de Conclusão</th>
            <th>Técnico</th>
            <th>Descrição</th>
            <th align="center">Concluída</th>
            <th></th>
          </tr>
        </thead>
        <tbody v-if="getAtividadesOs.length > 0">
          <tr v-for="a in getAtividadesOs" :key="a.id">
            <td>{{ a.data_inicio ? $helper.formatDate(a.data_inicio) : '' }} {{a.hora_inicio}}</td>
            <td>{{ a.data_termino ? $helper.formatDate(a.data_termino) : '' }} {{a.termino}}</td>
            <td>{{ a.tecnico ? a.tecnico.nome_abreviado : "" }}</td>
            <td>{{ a.descricao }}</td>
            <td>
              <v-icon v-if="a.concluida" color="success">done</v-icon>
              <v-icon v-else color="error">clear</v-icon>
            </td>
            <td>
              <TooltipButton
                @click.native="visualizarAtividadeOs(a.id)"
                classButton="ml-2"
                subtitle="Visualizar"
                icon="search"
                color="primary"
              />
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <ModalCadastro />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import ModalCadastro from "@/pages/ordemServico/atividade/ModalCadastro";

export default {
  components: {
    ModalCadastro,
  },
  computed: {
    ...mapGetters(["getAtividadesOs", "getOrdemServico"]),
  },
  methods: {
    ...mapActions([
      "cadastrarAtividadeOs",
      "setModalCadastroAtividadeOs",
      "setModalExlcuirAtividadeOs",
      "visualizarAtividadeOs",
    ]),
  },
  created() {
    // this.listarAtividadeOs(this.getOrdemServico);
  },
};
</script>
